import type { PropsWithChildren } from "react";

type PanelProps = PropsWithChildren<{
  title: string;
  accent?: string;
  className?: string;
}>;

export function Panel({ title, accent = "#2a2a3a", className, children }: PanelProps) {
  return (
    <section className={className} style={{ background: "rgba(255,255,255,0.03)", border: `1px solid ${accent}55`, borderRadius: 18, padding: 16, backdropFilter: "blur(12px)" }}>
      <div className="panel-title" style={{ color: accent }}>{title}</div>
      {children}
    </section>
  );
}
